import React, { useEffect, useState } from 'react';
import { Table } from 'antd';
import './PortfolioTable.scss';
import { CollapseDown, CollapseUp } from '../../assets/icons';

const PortfolioTable = (props) => {
  const { PortfolioTableHead, tableData, tableLoader, columns, count = 0, isOrder = false, handleOnScrollIntoView = () => {} } = props;

  const [currentCount, setCurrentCount] = useState(3);

  useEffect(() => {
    if (!isOrder) {
      setCurrentCount(count);
    }
  }, [count, isOrder]);
  return (
    <div className='PortfolioTable'>
      <div className='container-fluid'>
        <h4 className='fz-18 fw-600'>{PortfolioTableHead}</h4>
        <Table
          loading={tableLoader}
          columns={columns}
          dataSource={tableData?.slice(0, currentCount)}
          pagination={false}
          scroll={isOrder ? null : { x: 1200 }}
        />
        {isOrder && count > 3 ? (
          currentCount < tableData?.length ? (
            <div
              className='show-toggle cursor-pointer'
              onClick={(e) => {
                e.stopPropagation();
                setCurrentCount(tableData.length);
              }}
            >
              <span>Show All ({count})</span>
              <CollapseUp color='#8A4743' size='12' />
            </div>
          ) : (
            <div
              className='show-toggle cursor-pointer'
              onClick={(e) => {
                e.stopPropagation();
                setCurrentCount(3);
                handleOnScrollIntoView();
              }}
            >
              <span>See less</span>
              <CollapseDown color='#8A4743' size='12' />
            </div>
          )
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};

export default PortfolioTable;
